<template>
  <b-row
    @mouseover="onHover"
    @mouseleave="onLeave"
    @click="select()"
  >
    <b-col
      v-b-tooltip.hover.bottom="`${getNotationReportViewer}s to Exclude`"
      cols="2"
    >
      Excl. Obs.
    </b-col>
    <b-col>
      <multiselect
        v-model="selected"
        :hide-selected="true"
        :tag-placeholder="'Select ' + getNotationReportViewer"
        :placeholder="'Select exclude ' + getNotationReportViewer +'s'"
        label="value"
        track-by="value"
        :options="options"
        :multiple="true"
        :taggable="true"
        @tag="addTag"
        @select="setConfigReportModifiedReportViewer()"
        @remove="setConfigReportModifiedReportViewer()"
        @input="setConfigReportModifiedReportViewer()"
      />
    </b-col>
  </b-row>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions, mapGetters } from 'vuex'
import {hiddenConfCtrller} from '@/assets/classes/configuration.js'

const excludeConcCtrller = new hiddenConfCtrller('EXCLUDE_CONC_1DARRAY',['0'])

export default {
  name: 'ExcludeConcentrations',
  components: {
    Multiselect
  },
  props: { 
    sectionconfig:{
      type:String,
      required: true
    },
  },
    data() {
    return{
      excludeConcCtrller,
      elementsConfig:[],
      selected: [{value:'0'}],
      options: [
        {value:'0'},
      ],
      values:['0'],
      routeContextHelp:'' //Route for the Context Help it depends on the Section
    }
  },
  watch:{
    selected(){
      this.values.splice(0,this.values.length)
      this.selected.forEach(v=>this.values.push(v.value))
    }
  },
  computed: mapGetters([
    'getNotationReportViewer'
  ]),
  mounted() {
    this.elementsConfig = [
      this.excludeConcCtrller
    ]
    this.excludeConcCtrller.value = this.values
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.formatKeyValue(this.fitname))
    this.elementsConfig.forEach(conf=>conf.setParent(this))
    this.values = this.excludeConcCtrller.value
    const selectedAux = []
    this.values.forEach(v=>selectedAux.push({value:v}))
    this.selected = selectedAux
    this.routeContextHelp=`ReportViewer/Studies/${this.sectionconfig}/ExcludeConcentrations`
  },
  methods: {
    ...mapActions([
      'addMessageTerminalSection',
      'setContextOnHover',
      'setContextFixElement',
      'setConfigReportModifiedReportViewer'
    ]),
    addTag (newTag) {
      if(this.values.includes(newTag)){
        const warnTitle='Adding duplicate values'
        const warnText=`The element '${newTag}' already exist`
        const warnZone=`Exclude ${this.getNotationReportViewer}s`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING,warnTitle,warnText,warnZone)
        return
      }
      if(isNaN(parseFloat(newTag))){
        const errTitle='Adding duplicate values'
        const errText=`The element '${newTag}' is not a number`
        const errZone=`Exclude ${this.getNotationReportViewer}s`
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,errZone)
        return
      }
      const tag = {
        value: newTag
      }
      this.options.push(tag)
      this.selected.push(tag)
      this.setConfigReportModifiedReportViewer()
    },
    onHover() {
      this.setContextOnHover(this.routeContextHelp)
    },
    onLeave(){
      this.setContextOnHover(null)
    },
    select(){
      this.setContextFixElement(this.routeContextHelp)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
  ::v-deep .multiselect{
    margin-top: 5px;
    margin-bottom: 5px;
  }
  
  ::v-deep .form-group{
    margin-bottom: 0;
  }
</style>